import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import { DsRadioModule } from '@frontend/ui/radio-button';
import { ContentReadyTriggerDirective, trackByProp } from '@frontend/vanilla/core';
import { LabelSwitcherItem, LabelSwitcherService } from '@frontend/vanilla/features/label-switcher';
import { AccountMenuDataService } from '@frontend/vanilla/shared/account-menu';

import { AccountMenuTrackingService } from '../../src/account-menu-tracking.service';

@Component({
    imports: [CommonModule, DsRadioModule],
    selector: 'vn-label-switcher-menu',
    templateUrl: 'label-switcher-menu.html',
    hostDirectives: [ContentReadyTriggerDirective],
})
export class LabelSwitcherMenuComponent {
    service = inject(LabelSwitcherService);
    accountMenuDataService = inject(AccountMenuDataService);
    accountMenuTrackingService = inject(AccountMenuTrackingService);

    readonly trackByName = trackByProp<LabelSwitcherItem>('name');

    async switchLabel(item: LabelSwitcherItem) {
        if (item.isActive) return;

        this.accountMenuTrackingService.trackLabelSwitcherMenuClicked(item?.text, this.service.currentLabelItem()?.text, item.url);
        await this.service.switchLabel(item);
    }
}
